module.exports = new __parcel__URL__("rainbow-paint.ee812ea9.svg").toString();